import { Models } from "@hex-insights/app-modules";
import { CaseStyle, convertCase } from "@hex-insights/core";
import { EnrollmentApplicationStudent, EnrollmentApplicationStudentEnglishLanguageFluency } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the imageURL field of the EnrollmentApplicationStudent model.
 */
export function imageURL(value: EnrollmentApplicationStudent["imageURL"]): string {
	return Models.toString(value);
}

/**
 * Formats the name field of the EnrollmentApplicationStudent model.
 */
export function name(value: EnrollmentApplicationStudent["name"]): string {
	return Models.toString(value);
}

/**
 * Formats the givenName field of the EnrollmentApplicationStudent model.
 */
export function givenName(value: EnrollmentApplicationStudent["givenName"]): string {
	return Models.toString(value);
}

/**
 * Formats the middleName field of the EnrollmentApplicationStudent model.
 */
export function middleName(value: EnrollmentApplicationStudent["middleName"]): string {
	return Models.toString(value);
}

/**
 * Formats the familyName field of the EnrollmentApplicationStudent model.
 */
export function familyName(value: EnrollmentApplicationStudent["familyName"]): string {
	return Models.toString(value);
}

/**
 * Formats the nameOrder field of the EnrollmentApplicationStudent model.
 */
export function nameOrder(value: EnrollmentApplicationStudent["nameOrder"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}
	return convertCase(value, CaseStyle.Title);
}

/**
 * Formats the dateOfBirth field of the EnrollmentApplicationStudent model.
 */
export function dateOfBirth(value: EnrollmentApplicationStudent["dateOfBirth"] | null): string {
	return ModelFormat.date(value);
}

/**
 * Formats the gender field of the EnrollmentApplicationStudent model.
 */
export function gender(value: EnrollmentApplicationStudent["gender"]): string {
	return Models.toString(value);
}

/**
 * Formats the englishLanguageFluency field of the EnrollmentApplicationStudent model.
 */
export function englishLanguageFluency(value: EnrollmentApplicationStudent["englishLanguageFluency"] | null): string {
	if (value === null) {
		return "";
	}
	switch (value) {
		case EnrollmentApplicationStudentEnglishLanguageFluency.A1:
		case EnrollmentApplicationStudentEnglishLanguageFluency.A2:
		case EnrollmentApplicationStudentEnglishLanguageFluency.B1:
		case EnrollmentApplicationStudentEnglishLanguageFluency.B2:
		case EnrollmentApplicationStudentEnglishLanguageFluency.C1:
		case EnrollmentApplicationStudentEnglishLanguageFluency.C2:
			return value.toLocaleUpperCase();
		default:
			return convertCase(value, CaseStyle.Title);
	}
}

/**
 * Formats the questionnaireActivities field of the EnrollmentApplicationStudent model.
 */
export function questionnaireActivities(value: EnrollmentApplicationStudent["questionnaireActivities"]): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireHasPsychTreatment field of the EnrollmentApplicationStudent model.
 */
export function questionnaireHasPsychTreatment(
	value: EnrollmentApplicationStudent["questionnaireHasPsychTreatment"],
): string {
	return Models.toString(value);
}

/**
 * Formats the questionnairePsychTreatmentDescription field of the EnrollmentApplicationStudent model.
 */
export function questionnairePsychTreatmentDescription(
	value: EnrollmentApplicationStudent["questionnairePsychTreatmentDescription"],
): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireHasSpecialNeeds field of the EnrollmentApplicationStudent model.
 */
export function questionnaireHasSpecialNeeds(
	value: EnrollmentApplicationStudent["questionnaireHasSpecialNeeds"],
): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireSpecialNeedsDescription field of the EnrollmentApplicationStudent model.
 */
export function questionnaireSpecialNeedsDescription(
	value: EnrollmentApplicationStudent["questionnaireSpecialNeedsDescription"],
): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireHasBehaviors field of the EnrollmentApplicationStudent model.
 */
export function questionnaireHasBehaviors(value: EnrollmentApplicationStudent["questionnaireHasBehaviors"]): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireBehaviorsDescription field of the EnrollmentApplicationStudent model.
 */
export function questionnaireBehaviorsDescription(
	value: EnrollmentApplicationStudent["questionnaireBehaviorsDescription"],
): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireDescription field of the EnrollmentApplicationStudent model.
 */
export function questionnaireDescription(value: EnrollmentApplicationStudent["questionnaireDescription"]): string {
	return Models.toString(value);
}

/**
 * Formats the questionnaireAdditionalInformation field of the EnrollmentApplicationStudent model.
 */
export function questionnaireAdditionalInformation(
	value: EnrollmentApplicationStudent["questionnaireAdditionalInformation"],
): string {
	return Models.toString(value);
}
